import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { GameQuestion } from '../../../interfaces/question.interface';
import { GlobalService } from 'src/app/_services/global.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { trigger, transition, style, animate } from '@angular/animations';

@Component({
  selector: 'app-question-card',
  templateUrl: './question-card.component.html',
  styleUrls: ['./question-card.component.scss'],
  animations: [
    trigger('fadeIn', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(20px)' }),
        animate('0.4s ease-out', style({ opacity: 1, transform: 'translateY(0)' }))
      ])
    ])
  ]
})
export class QuestionCardComponent implements OnInit, OnDestroy {
  @Input() question: GameQuestion;
  @Input() selectedOption: 'A' | 'B' | 'C' | 'D' | null = null;
  @Output() optionSelected = new EventEmitter<'A' | 'B' | 'C' | 'D'>();

  private destroy$ = new Subject<void>();
  currLang: any = 'en';

  optionColors = ['#4CAF50', '#FF9800', '#2196F3', '#E91E63'];
  optionLabels = ['A', 'B', 'C', 'D'];
  private arabicLabels: Record<string, string> = { 'A': 'أ', 'B': 'ب', 'C': 'ج', 'D': 'د' };

  constructor(private globalService: GlobalService) {}

  ngOnInit(): void {
    this.globalService.getLang()
      .pipe(takeUntil(this.destroy$))
      .subscribe(lang => this.currLang = lang);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getQuestionText(): string {
    return this.currLang === 'ar' ? this.question.text.ar : this.question.text.en;
  }

  getOptionText(option: any): string {
    return this.currLang === 'ar' ? option.text.ar : option.text.en;
  }

  getOptionLabel(id: string): string {
    return this.currLang === 'ar' ? (this.arabicLabels[id] || id) : id;
  }

  selectOption(optionId: 'A' | 'B' | 'C' | 'D'): void {
    this.optionSelected.emit(optionId);
  }
}
